import {
    ComputeStatus,
    DataSourceWithConfiguration,
} from "@biggeo/bg-server-lib/studio";
import {
    CircularLoading,
    Grid,
    IconButton,
    Typography,
} from "@biggeo/bg-ui/lab";
import { PlayArrowOutline } from "@biggeo/bg-ui/lab/icons";
import { TurnOffCompute } from "../views/TurnOffCompute";

export type ComputeViewProps = {
    readonly datasourceWithConfig: DataSourceWithConfiguration;
    readonly onClick: () => void;
    readonly updateLoading: boolean;
};

export const ComputeToggleContainer = ({
    datasourceWithConfig,
    onClick,
    updateLoading,
}: ComputeViewProps) => {
    const isOn =
        datasourceWithConfig.configuration.status === ComputeStatus.hot;
    const isLoading =
        datasourceWithConfig.configuration.status === ComputeStatus.loading;

    return (
        <Grid container alignItems="center" justifyContent="center" gap={1}>
            {updateLoading ? (
                <IconButton
                    rounded
                    variant="tonal"
                    density="dense"
                    disabled={isLoading}
                >
                    <CircularLoading size="md" />
                </IconButton>
            ) : isOn || isLoading ? (
                <TurnOffCompute
                    onClick={onClick}
                    lastEnabled={datasourceWithConfig.configuration.lastEnabled}
                />
            ) : (
                <>
                    <IconButton
                        variant="tonal"
                        density="dense"
                        sx={{
                            borderRadius: (theme) => theme.radius.full,
                        }}
                        disabled={isLoading || !isOn}
                    >
                        <PlayArrowOutline
                            color={!isOn ? "disabled" : "primary"}
                            invertColors
                            colorSet="container"
                        />
                    </IconButton>
                    <Typography
                        variant="body3"
                        fontWeight="semibold"
                        textColor={!isOn ? "disabled.onContainer" : undefined}
                    >
                        Turn On
                    </Typography>
                </>
            )}
        </Grid>
    );
};
